import { useLanguage } from "@/contexts/LanguageContext";
import { publicRoutes } from "@/i18n/routes";

/**
 * Returns the localized path for the current language.
 * Usage: const path = useLocalePath("/over-ons"); // returns "/about" in EN mode
 */
export function useLocalePath() {
  const { language } = useLanguage();

  return (nlPath: string): string => {
    if (language === "nl") return nlPath;

    // Find the route config for this NL path
    const route = publicRoutes.find((r) => r.nl === nlPath);
    if (route) {
      return `/en${route.en}`;
    }

    // Fallback: add /en prefix
    return `/en${nlPath}`;
  };
}
